import { createIcon } from '@chakra-ui/react';
import {
  mdiCheck,
  mdiCheckDecagram,
  mdiCloseCircle,
  mdiClose,
  mdiMinusCircleOutline,
  mdiHandBackLeft,
  mdiMagnify,
  mdiPauseCircle,
  mdiSortAscending,
  mdiSortDescending,
  mdiTrashCan,
  mdiTrashCanOutline,
  mdiAccountCircle,
  mdiDotsHorizontal,
  mdiCalendarCheck,
  mdiCog,
  mdiCogOutline,
  mdiArchive,
  mdiArchiveOutline,
  mdiLogoutVariant,
  mdiFlag,
  mdiHistory,
  mdiArrowRight,
  mdiArrowRightThick,
  mdiArrowRightThin,
  mdiArrowLeft,
  mdiArrowLeftThick,
  mdiInformationOutline,
  mdiArrowDownRight,
  mdiPencil,
  mdiCircleMultiple,
  mdiAlphaPBox,
  mdiCheckAll,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiCheckboxOutline,
  mdiGrid,
  mdiGridOff,
  mdiHelpCircleOutline,
  mdiRefresh,
  mdiCancel,
  mdiNote,
  mdiNoteAlert,
  mdiNoteEditOutline,
  mdiPercentCircle,
  mdiMargin,
  mdiMultiplicationBox,
  mdiPlus,
  mdiFileExport,
  mdiResizeBottomRight,
  mdiCalculator,
  mdiCircleMedium,
  mdiDownload,
  mdiUpload,
  mdiUploadBoxOutline,
  mdiArrowRightTopBold,
  mdiCircle,
  mdiCircleOutline,
  mdiArrowExpand,
  mdiArrowCollapse,
  mdiChevronDown,
  mdiChevronUp,
  mdiUndoVariant,
  mdiEyeOffOutline,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiOpenInNew,
  mdiClockOutline,
  mdiFilterVariant,
  mdiContentCopy,
  mdiArrowUpLeft,
  mdiViewGrid,
  mdiViewList,
  mdiDrag,
  mdiPackageVariant,
  mdiCube,
  mdiImageOutline,
  mdiImageBrokenVariant,
  mdiFolderOutline,
  mdiFilePlusOutline,
  mdiFileOutline,
  mdiFileReplaceOutline,
  mdiPencilRuler,
  mdiLock,
  mdiLockOpen,
  mdiSlashForward,
  mdiLockQuestion,
  mdiShieldAccount,
  mdiShieldCrown,
  mdiAccountSupervisorCircle,
  mdiShieldKey,
  mdiShieldEdit,
  mdiCellphoneLinkOff,
  mdiEmailFast,
  mdiMinus,
  mdiCamera,
  mdiRename,
  mdiThumbUp,
  mdiArrowDown,
  mdiArrowCollapseRight,
  mdiArrowExpandDown,
  mdiAxisArrow,
  mdiChevronRight,
  mdiDotsGrid,
  mdiEye,
  mdiEyeCheck,
  mdiLayers,
  mdiPaletteSwatch,
  mdiLayersOutline,
  mdiLayersPlus,
  mdiLink,
  mdiKeyboardEsc,
  mdiCropFree,
  mdiPackageVariantClosed,
  mdiPackageVariantClosedCheck,
  mdiTruck,
  mdiTruckDelivery,
  mdiSendClock,
  mdiCloudQuestion,
  mdiCubeSend,
  mdiTarget,
  mdiHelp,
  mdiPackageVariantClosedPlus,
  mdiPackageVariantMinus,
  mdiTruckCheck,
  mdiBullseyeArrow,
  mdiBriefcaseArrowLeftRight,
  mdiCircleOpacity,
  mdiFactory,
  mdiArrowRightBottom,
  mdiEmail,
  mdiChat,
  mdiSwapHorizontal,
  mdiFileExcelBox,
  mdiFilePdfBox,
  mdiWeatherNight,
  mdiWhiteBalanceSunny,
  mdiTruckFast,
  mdiGift,
  mdiGiftOpen,
  mdiArrowDownThick,
  mdiSend,
  mdiTimelineRemove,
  mdiCashMultiple,
  mdiTextureBox,
  mdiRulerSquare,
  mdiHomeMapMarker,
  mdiTag,
  mdiFilterCog,
  mdiAccountGroup,
  mdiCashMinus,
  mdiCashPlus,
  mdiFormatAlignLeft,
  mdiFormatAlignCenter,
  mdiFormatAlignRight,
} from '@mdi/js';

const enlargedIconProps = {
  defaultProps: { boxSize: '2em' },
};

export const defaultIconSize = 5;

export const Icons = {
  Search: createIcon({ d: mdiMagnify }),
  Email: createIcon({ d: mdiEmail }),
  Chat: createIcon({ d: mdiChat }),
  BriefcaseArrowLeftRight: createIcon({ d: mdiBriefcaseArrowLeftRight }),
  Trash: createIcon({ d: mdiTrashCan }),
  SwapHorizontal: createIcon({ d: mdiSwapHorizontal }),
  TrashOutline: createIcon({ d: mdiTrashCanOutline }),
  Checkmark: createIcon({ d: mdiCheck }),
  SortAscending: createIcon({ d: mdiSortAscending }),
  SortDescending: createIcon({ d: mdiSortDescending }),
  Minus: createIcon({ d: mdiMinus }),
  Camera: createIcon({ d: mdiCamera }),
  HomeMapMarker: createIcon({ d: mdiHomeMapMarker }),
  CheckmarkDecagram: createIcon({
    d: mdiCheckDecagram,
    ...enlargedIconProps,
  }),
  BreifcaseArrowLeftRight: createIcon({ d: mdiBriefcaseArrowLeftRight }),
  CropFree: createIcon({ d: mdiCropFree }),
  CloseCircle: createIcon({ d: mdiCloseCircle, ...enlargedIconProps }),
  Close: createIcon({ d: mdiClose }),
  MinusCircleOutline: createIcon({ d: mdiMinusCircleOutline }),
  HandBackLeft: createIcon({ d: mdiHandBackLeft, ...enlargedIconProps }),
  PauseCircle: createIcon({ d: mdiPauseCircle, ...enlargedIconProps }),
  AccountCircle: createIcon({ d: mdiAccountCircle }),
  DotsHorizontal: createIcon({ d: mdiDotsHorizontal }),
  CalendarCheck: createIcon({ d: mdiCalendarCheck }),
  Cog: createIcon({ d: mdiCog }),
  CogOutline: createIcon({ d: mdiCogOutline }),
  Lock: createIcon({ d: mdiLock }),
  LockOpen: createIcon({ d: mdiLockOpen }),
  Archive: createIcon({ d: mdiArchive }),
  ArchiveOutline: createIcon({ d: mdiArchiveOutline }),
  Logout: createIcon({ d: mdiLogoutVariant }),
  Flag: createIcon({ d: mdiFlag }),
  History: createIcon({ d: mdiHistory }),
  Send: createIcon({ d: mdiSend }),
  ArrowRight: createIcon({ d: mdiArrowRight }),
  ArrowRightBottom: createIcon({ d: mdiArrowRightBottom }),
  ArrowRightThick: createIcon({ d: mdiArrowRightThick }),
  ArrowRightThin: createIcon({ d: mdiArrowRightThin }),
  ArrowLeft: createIcon({ d: mdiArrowLeft }),
  ArrowLeftThick: createIcon({ d: mdiArrowLeftThick }),
  InformationOutline: createIcon({ d: mdiInformationOutline }),
  ArrowDownRight: createIcon({ d: mdiArrowDownRight }),
  ArrowCollapseRight: createIcon({ d: mdiArrowCollapseRight }),
  ArrowExpandDown: createIcon({ d: mdiArrowExpandDown }),
  Pencil: createIcon({ d: mdiPencil }),
  CircleMultiple: createIcon({ d: mdiCircleMultiple }),
  AlphaPBox: createIcon({ d: mdiAlphaPBox }),
  Undo: createIcon({ d: mdiUndoVariant }),
  CheckAll: createIcon({ d: mdiCheckAll }),
  AlertCircle: createIcon({ d: mdiAlertCircle }),
  AlertCircleOutline: createIcon({ d: mdiAlertCircleOutline }),
  CheckboxOutline: createIcon({ d: mdiCheckboxOutline }),
  Grid: createIcon({ d: mdiGrid }),
  GridOff: createIcon({ d: mdiGridOff }),
  HelpCircleOutline: createIcon({ d: mdiHelpCircleOutline }),
  Refresh: createIcon({ d: mdiRefresh }),
  Cancel: createIcon({ d: mdiCancel }),
  Note: createIcon({ d: mdiNote }),
  NoteAlert: createIcon({ d: mdiNoteAlert }),
  NoteEdit: createIcon({ d: mdiNoteEditOutline }),
  PercentCircle: createIcon({ d: mdiPercentCircle }),
  Margin: createIcon({ d: mdiMargin }),
  MultiplicationBox: createIcon({ d: mdiMultiplicationBox }),
  Plus: createIcon({ d: mdiPlus }),
  FileExport: createIcon({ d: mdiFileExport }),
  ResizeBottomRight: createIcon({ d: mdiResizeBottomRight }),
  Calculator: createIcon({ d: mdiCalculator }),
  CircleMedium: createIcon({ d: mdiCircleMedium }),
  Download: createIcon({ d: mdiDownload }),
  Upload: createIcon({ d: mdiUpload }),
  UploadBoxOutline: createIcon({ d: mdiUploadBoxOutline }),
  ArrowRightTopBold: createIcon({ d: mdiArrowRightTopBold }),
  Circle: createIcon({ d: mdiCircle }),
  CircleOutline: createIcon({ d: mdiCircleOutline }),
  ArrowExpand: createIcon({ d: mdiArrowExpand }),
  ArrowCollapse: createIcon({ d: mdiArrowCollapse }),
  ChevronUp: createIcon({ d: mdiChevronUp }),
  ChevronDown: createIcon({ d: mdiChevronDown }),
  EyeOff: createIcon({ d: mdiEyeOffOutline }),
  CheckCircle: createIcon({ d: mdiCheckCircle }),
  CheckCircleOutline: createIcon({ d: mdiCheckCircleOutline }),
  OpenInNew: createIcon({ d: mdiOpenInNew }),
  Clock: createIcon({ d: mdiClockOutline }),
  FilterVariant: createIcon({ d: mdiFilterVariant }),
  FilterCog: createIcon({ d: mdiFilterCog }),
  ContentCopy: createIcon({ d: mdiContentCopy }),
  ArrowUpLeft: createIcon({ d: mdiArrowUpLeft }),
  ViewTable: createIcon({ d: mdiViewList }),
  ViewCard: createIcon({ d: mdiViewGrid }),
  Drag: createIcon({ d: mdiDrag }),
  PackageVariant: createIcon({ d: mdiPackageVariant }),
  Cube: createIcon({ d: mdiCube }),
  ImageOutline: createIcon({ d: mdiImageOutline }),
  ImageBrokenVariant: createIcon({ d: mdiImageBrokenVariant }),
  FolderOutline: createIcon({ d: mdiFolderOutline }),
  FilePlusOutline: createIcon({ d: mdiFilePlusOutline }),
  FileOutline: createIcon({ d: mdiFileOutline }),
  FileReplaceOutline: createIcon({ d: mdiFileReplaceOutline }),
  PencilRuler: createIcon({ d: mdiPencilRuler }),
  SlashForward: createIcon({ d: mdiSlashForward }),
  LockQuestion: createIcon({ d: mdiLockQuestion }),
  ShieldAccount: createIcon({ d: mdiShieldAccount }),
  ShieldCrown: createIcon({ d: mdiShieldCrown }),
  AccountSupervisorCircle: createIcon({ d: mdiAccountSupervisorCircle }),
  ShieldKey: createIcon({ d: mdiShieldKey }),
  ShieldEdit: createIcon({ d: mdiShieldEdit }),
  CellphoneLinkOff: createIcon({ d: mdiCellphoneLinkOff }),
  EmailFast: createIcon({ d: mdiEmailFast }),
  ThumbUp: createIcon({ d: mdiThumbUp }),
  Rename: createIcon({ d: mdiRename }),
  ChevronRight: createIcon({ d: mdiChevronRight }),
  EyeCheck: createIcon({ d: mdiEyeCheck }),
  Eye: createIcon({ d: mdiEye }),
  CashMinus: createIcon({ d: mdiCashMinus }),
  CashPlus: createIcon({ d: mdiCashPlus }),
  AxisArrow: createIcon({ d: mdiAxisArrow }),
  Layers: createIcon({ d: mdiLayers }),
  PaletteSwatch: createIcon({ d: mdiPaletteSwatch }),
  ArrowDown: createIcon({ d: mdiArrowDown }),
  ArrowDownThick: createIcon({ d: mdiArrowDownThick }),
  DotsGrid: createIcon({ d: mdiDotsGrid }),
  LayersPlus: createIcon({ d: mdiLayersPlus }),
  LayersOutline: createIcon({ d: mdiLayersOutline }),
  Link: createIcon({ d: mdiLink }),
  keyboardEscape: createIcon({ d: mdiKeyboardEsc }),
  PackageVariantClosed: createIcon({ d: mdiPackageVariantClosed }),
  TextureBox: createIcon({ d: mdiTextureBox }),
  RulerSquare: createIcon({ d: mdiRulerSquare }),
  PackageVariantClosedCheck: createIcon({ d: mdiPackageVariantClosedCheck }),
  Gift: createIcon({ d: mdiGift }),
  GiftOpen: createIcon({ d: mdiGiftOpen }),
  TruckDelivery: createIcon({ d: mdiTruckDelivery }),
  Truck: createIcon({ d: mdiTruck }),
  TruckFast: createIcon({ d: mdiTruckFast }),
  SendClock: createIcon({ d: mdiSendClock }),
  CloudQuestion: createIcon({ d: mdiCloudQuestion }),
  Target: createIcon({ d: mdiTarget }),
  CubeSend: createIcon({ d: mdiCubeSend }),
  Help: createIcon({ d: mdiHelp }),
  CashMultiple: createIcon({ d: mdiCashMultiple }),
  PackageVariantClosedPlus: createIcon({ d: mdiPackageVariantClosedPlus }),
  PackageVariantRemove: createIcon({ d: mdiPackageVariantMinus }),
  TruckCheck: createIcon({ d: mdiTruckCheck }),
  BullseyeArrow: createIcon({ d: mdiBullseyeArrow }),
  KeyboardEscape: createIcon({ d: mdiKeyboardEsc }),
  CircleOpacity: createIcon({ d: mdiCircleOpacity }),
  TimelineRemove: createIcon({ d: mdiTimelineRemove }),
  Factory: createIcon({ d: mdiFactory }),
  FileExcelBox: createIcon({ d: mdiFileExcelBox }),
  FilePdfBox: createIcon({ d: mdiFilePdfBox }),
  WeatherNight: createIcon({ d: mdiWeatherNight }),
  WhiteBalanceSunny: createIcon({ d: mdiWhiteBalanceSunny }),
  Tag: createIcon({ d: mdiTag }),
  Users: createIcon({ d: mdiAccountGroup }),
  FormatAlignLeft: createIcon({ d: mdiFormatAlignLeft }),
  FormatAlignCenter: createIcon({ d: mdiFormatAlignCenter }),
  FormatAlignRight: createIcon({ d: mdiFormatAlignRight }),
};
